import { __spreadArray } from "tslib";
export var modifyFontFamily = function (modifierFn) { return function (fontFamily) {
    return fontFamily
        .split(',')
        .map(function (ff) { return cleanFontFamilyName(ff); })
        .map(modifierFn)
        .reduce(function (acc, curr) { return __spreadArray(__spreadArray([], acc), curr); }, [])
        .filter(Boolean)
        .join(',');
}; };
function cleanFontFamilyName(fontFamilyName) {
    return fontFamilyName.trim().replace(/"/g, '').replace(/'/g, '');
}
//# sourceMappingURL=modify-font-family.js.map